import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { useApiFetcher } from "../ApiProvider";
import { QUERY_KEYS } from "../queryKeys";
import type { BonusAvailableResponse, BonusHistoryResponse, BonusTomorrowResponse } from "../types";
export function useBonusAvailable() {
  const $ = _c(2);
  const apiFetcher = useApiFetcher();
  let t0;
  if ($[0] !== apiFetcher) {
    t0 = {
      queryKey: QUERY_KEYS.BONUS_AVAILABLE,
      queryFn: () => apiFetcher("/api/v1/bonus/available"),
      staleTime: 3600000,
      refetchInterval: 3600000,
      refetchOnWindowFocus: true
    };
    $[0] = apiFetcher;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useQuery(t0);
}
export function useBonusHistory(t0) {
  const $ = _c(8);
  const limit = t0 === undefined ? 20 : t0;
  const apiFetcher = useApiFetcher();
  let t1;
  if ($[0] !== limit) {
    t1 = [...QUERY_KEYS.BONUS_HISTORY, limit];
    $[0] = limit;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== apiFetcher || $[3] !== limit) {
    t2 = () => apiFetcher(`/api/v1/bonus/history?limit=${limit}`);
    $[2] = apiFetcher;
    $[3] = limit;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = {
      queryKey: t1,
      queryFn: t2,
      staleTime: 60000,
      refetchOnWindowFocus: false
    };
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return useQuery(t3);
}
export function useBonusTomorrow() {
  const $ = _c(2);
  const apiFetcher = useApiFetcher();
  let t0;
  if ($[0] !== apiFetcher) {
    t0 = {
      queryKey: QUERY_KEYS.BONUS_TOMORROW,
      queryFn: () => apiFetcher("/api/v1/bonus/tomorrow"),
      staleTime: 3600000,
      refetchInterval: 3600000,
      refetchOnWindowFocus: false
    };
    $[0] = apiFetcher;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useQuery(t0);
}